import PropTypes from 'prop-types'
import { useState, useEffect, useContext } from 'react'
import sinDniDorso from '../../../src/img/dni_dorso.jpg'
import sinDniFrente from '../../../src/img/dni_frente.jpg'
import { UsuarioContext } from '../context/usuarioContext'
import * as imagenesPerfilService from '../servicios/imagenesPerfilService'

const ImagenDni = ({ idUsuario, clase, idTipo, download = false }) => {
  const [imagenUrl, setImagenUrl] = useState('')
  const [loading, setLoading] = useState(true)

  const { imagenModif } = useContext(UsuarioContext)

  useEffect(() => {
    obtenerImagen()
  }, [imagenModif])

  const obtenerImagen = async () => {
    const { data: imagenp } = await imagenesPerfilService.buscarImagen(idUsuario, idTipo)
    //console.log(imagenp);
    const imagenUrl =
      imagenp.size !== 0
        ? URL.createObjectURL(imagenp)
        : idTipo === 1
          ? sinDniFrente
          : sinDniDorso
    setImagenUrl(imagenUrl)
    setLoading(false)
    //revokeObjectURL
  }
  return (
    <>
      {loading ? (
        <div className="spinner-border text-secondary">
          <span className="sr-only"></span>
        </div>
      ) : (
        <a href={download ? imagenUrl : '#'} download={download && 'download'}>
          <img src={imagenUrl} className={clase} width="150" alt="dni"></img>
        </a>
      )}
    </>
  )
}

ImagenDni.propTypes = {
  idUsuario: PropTypes.number.isRequired,
  clase: PropTypes.string.isRequired,
  idTipo: PropTypes.number.isRequired,
  download: PropTypes.bool
}

export default ImagenDni
